import { ScrollArea } from "@mantine/core";
import { useMyReferralProfile } from "../../queries/get-my-referral-profile";
import { RewardCodeCard } from "./reward-code-card";

export function RewardsSection() {
	const { data: profile } = useMyReferralProfile();
	const rewards = profile?.rewards ?? [];

	return (
		<div className="flex flex-col gap-3 mb-5">
			<p className="uppercase tracking-wider text-text-muted text-xs font-bold">
				Your Rewards
			</p>
			{rewards.length > 0 ? (
				<ScrollArea
					mah={300}
					classNames={{
						scrollbar: "custom-scrollbar",
					}}
				>
					<div className="space-y-2 pr-2">
						{rewards.map((reward) => (
							<RewardCodeCard key={reward.rewardCode} reward={reward} />
						))}
					</div>
				</ScrollArea>
			) : (
				<div className="flex flex-col items-center justify-center py-5 rounded-xl border border-dashed border-border-default bg-surface-subtle/50 text-center gap-1">
					<span className="text-2xl">🔒</span>
					<p className="text-xs font-semibold text-text-secondary mt-1">
						No rewards yet
					</p>
					<p className="text-[11px] text-text-muted max-w-50 leading-snug">
						Invite friends to start earning free Pro months.
					</p>
				</div>
			)}
		</div>
	);
}
